import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getBills, saveBillPayment } from "services/BookingService";
import { getAgents } from "services/AgentService";
import { useAuth } from "hooks/useAuth";

const BillingsList = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [agents, setAgents] = useState([]);
  const [bills, setBills] = useState([]);
  const [successMsg, setSuccessMsg] = useState(null);
  const [errorMsg, setErroMsg] = useState(null);
  const [paymentForms, setPaymentForms] = useState({});
  const [paymentLoading, setPaymentLoading] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterBills, setFilteredBillings] = useState([]);
  const { hasPermission } = useAuth();
  const [filters, setFilters] = useState({
    agentId: "",
    invoiceNo: "",
    status: "",
    limit: 10,
  });
  useEffect(() => {
    getAgentsList();
    getBillsList();
  }, []);

  const getAgentsList = () => {
    getAgents().then((response) => {
      if (response && response.data.success) {
        setAgents(response.data.agents);
      }
    });
  };

  const getBillsList = () => {
    getBills().then((response) => {
      if (response && response.data.success) {
        setBills(response.data.billings);
        setFilteredBillings(response.data.billings);
      }
    });
  };

  const handlePaymentChange = (billId, field, value) => {
    setPaymentForms({
      ...paymentForms,
      [billId]: {
        ...paymentForms[billId],
        [field]: value,
      },
    });
  };

  const handleAddPayment = async (e, billId) => {
    e.preventDefault();
    const paymentData = paymentForms[billId];
    let payload = {};
    payload = paymentData;
    payload.billing_id = billId;
    setPaymentLoading({ ...paymentLoading, [billId]: true });
    try {
      let response = await saveBillPayment(payload);
      setPaymentLoading({ ...paymentLoading, [billId]: false });
      if (response?.data?.success) {
        getBillsList();
      } else {
        // setErroMsg(response?.data?.message);
      }
      setPaymentForms({
        ...paymentForms,
        [billId]: { date: "", amount: "", remark: "" },
      });
    } catch (error) {
      console.error("Failed to add payment:", error);
    } finally {
      setPaymentLoading({ ...paymentLoading, [billId]: false });
    }
  };

  const totalAdvance = (index) => {
    const totalAdvanceAmount = bills[index].payments.reduce(
      (sum, payment) => sum + Number(payment.amount),
      0
    );
    return totalAdvanceAmount;
  };
  const totalBalnce = (index) => {
    const totalCost = bills[index].total_cost;
    const totalAdvanceAmount =
      Number(bills[index].total_advance) +
      bills[index].payments.reduce(
        (sum, payment) => sum + Number(payment.amount),
        0
      );
    const totalBalnce = totalCost - totalAdvanceAmount;
    return totalBalnce;
  };

  const handleSearch = () => {
    // Example: console log or make API call
    console.log("Filters applied:", filters);

    // Example if you want to filter an existing `billings` array:
    let filteredBills = bills;

    if (filters.agentId && filters.agentId !== "disable") {
      filteredBills = filteredBills.filter(
        (bill) => bill.agent_id == filters.agentId
      );
    }

    if (filters.invoiceNo) {
      filteredBills = filteredBills.filter(
        (bill) => bill.invoice_no == filters.invoiceNo
      );
    }

    if (filters.status && filters.status !== "disable") {
      filteredBills = filteredBills.filter(
        (bill) => bill.status === filters.status
      );
    }

    // Apply limit (optional)
    if (filters.limit !== "-1") {
      filteredBills = filteredBills.slice(0, Number(filters.limit));
    }

    //console.log('Filtered Bills:', filteredBills);

    // Set filtered bills in a new state to render
    setFilteredBillings(filteredBills);
  };

  const handleChangePage = (newPage) => setPage(newPage);
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const paginatedBookings = filterBills.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <>
      <section className="content-header">
        <div class="header-icon">
          <i class="fa fa-users"></i>
        </div>
        <div className="header-title">
          <h1>Manage Billings</h1>
          <small>Billings List</small>
        </div>
      </section>

      <section className="content">
        <div className="row">
          <div className="col-lg-12 pinpin p-0">
            <div className="buttonexport" id="buttonlist">
            {hasPermission("Add Billing") && (
              <Link className="btn btn-add" to="/add-billing">
                <i className="fa fa-file-text-o"></i> Generate Bill
              </Link>
            )}
            </div>
            <div className="card lobicard mt-2" data-sortable="true">
              <div className="card-header">
                <div className="card-title custom_title">
                  <h4>Billing List</h4>
                </div>
              </div>
              <div className="card-body">
                <div id="Filter-sec">
                  <div className="btn-group ml-3">
                    <select
                      value={rowsPerPage}
                      onChange={handleRowsPerPageChange}
                      className="form-control w-auto mr-3"
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                  </div>

                  <div className="filter-input">
                    <div
                      className="search-form-input-3 ml-2 "
                      id="first-select"
                    >
                      <select
                        id="FilterSelect"
                        value={filters.agentId}
                        onChange={(e) =>
                          setFilters({ ...filters, agentId: e.target.value })
                        }
                      >
                        <option value="disable">Search Agent Name</option>
                        {agents.map((agent) => (
                          <option key={agent.id} value={agent.id}>
                            {agent.agent_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="filter-input">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Invoice No."
                      value={filters.invoiceNo}
                      onChange={(e) =>
                        setFilters({ ...filters, invoiceNo: e.target.value })
                      }
                    />
                  </div>

                  <div className="filter-input">
                    <select
                      name="status"
                      value={filters.status}
                      onChange={(e) =>
                        setFilters({ ...filters, status: e.target.value })
                      }
                    >
                      <option value="disable">Bill Status</option>
                      <option value="1">Paid</option>
                      <option value="0">Unpaid</option>
                    </select>
                  </div>

                  <div className="btn-group ml-3">
                    <button className="btn btn-add" onClick={handleSearch}>
                      Search
                    </button>
                  </div>
                </div>
                <hr />
              </div>
              <div className="row">
                <div className="col-lg-12 pinpin">
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table
                        id="dataTableExample1"
                        className="table table-bordered table-striped table-hover"
                      >
                        <thead className="back_table_color">
                          <tr className="info">
                            <th>Sno. </th>
                            <th>Invoice No </th>
                            <th>Agent Name </th>
                            <th>From Date </th>
                            <th>To Date </th>
                            <th>Total Amount </th>
                            <th>Total Advance</th>
                            <th>Balance</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filterBills.length > 0 ? (
                            filterBills.map((bill, pindex) => (
                              <>
                                <tr>
                                  <td>{pindex + 1} </td>
                                  <td>{bill.invoice_no} </td>
                                  <td>{bill?.agent?.agent_name}</td>
                                  <td>{bill.from_date}</td>
                                  <td>{bill.to_date}</td>
                                  <td>{bill.total_cost}</td>
                                  <td> { Number(bill.total_advance )+ Number(bill.payments.reduce((sum, payment) => sum + Number(payment.amount || 0), 0))}</td>
                                  <td>
                                    {bill.total_cost - (Number(bill.total_advance )+ Number(bill.payments.reduce((sum, payment) => sum + Number(payment.amount || 0), 0)))}
                                  </td>
                                  <td>
                                    {(bill.total_cost - (Number(bill.total_advance )+ Number(bill.payments.reduce((sum, payment) => sum + Number(payment.amount || 0), 0)))<=0) ? (
                                      <span className="label-custom label label-default">
                                        Paid
                                      </span>
                                    ) : (
                                      <span className="label-danger label label-default">
                                        Unpaid
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm "
                                      data-toggle="collapse"
                                      data-target={"#details" + bill.id}
                                      aria-expanded="false"
                                      aria-controls={"#details" + bill.id}
                                    >
                                      View All{" "}
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-add btn-sm"
                                      data-toggle="modal"
                                      data-target="#customer1"
                                    >
                                      <i className="fa fa-download"></i>
                                    </button>
                                  </td>
                                </tr>

                                <tr
                                  id={"details" + bill.id}
                                  className="collapse"
                                >
                                  <td colspan="10">
                                    <div className="card-body p-0">
                                      <form
                                        className="col-sm-12"
                                        onSubmit={(e) =>
                                          handleAddPayment(e, bill.id)
                                        }
                                      >
                                        <div className="row">
                                          <div className="col-lg-3 col-md-6 mb-3">
                                            <div className="form-group">
                                              <label>Date</label>
                                              <input
                                                type="date"
                                                className="form-control"
                                                value={
                                                  paymentForms[bill.id]?.date ||
                                                  ""
                                                }
                                                onChange={(e) =>
                                                  handlePaymentChange(
                                                    bill.id,
                                                    "date",
                                                    e.target.value
                                                  )
                                                }
                                                required
                                              />
                                            </div>
                                          </div>
                                          <div className="col-lg-3 col-md-6 mb-3">
                                            <div className="form-group">
                                              <label>Amount</label>
                                              <input
                                                type="number"
                                                className="form-control"
                                                value={
                                                  paymentForms[bill.id]
                                                    ?.amount || ""
                                                }
                                                onChange={(e) =>
                                                  handlePaymentChange(
                                                    bill.id,
                                                    "amount",
                                                    e.target.value
                                                  )
                                                }
                                                required
                                              />
                                            </div>
                                          </div>
                                          <div className="col-lg-3 col-md-6 mb-3">
                                            <div className="form-group">
                                              <label>Remark</label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  paymentForms[bill.id]
                                                    ?.remark || ""
                                                }
                                                onChange={(e) =>
                                                  handlePaymentChange(
                                                    bill.id,
                                                    "remark",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div className="col-lg-3 col-md-6 mb-3">
                                            <div className="reset-button">
                                              <button
                                                type="submit"
                                                className="btn btn-success generate-bill"
                                                disabled={
                                                  paymentLoading[bill.id]
                                                }
                                              >
                                                {paymentLoading[bill.id] ? (
                                                  <>
                                                    <i className="fa fa-spinner fa-spin"></i>{" "}
                                                    Adding...
                                                  </>
                                                ) : (
                                                  "Add Payment"
                                                )}
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </form>
                                    </div>

                                    <table className="table table-bordered table-striped table-hover">
                                      <thead>
                                        <tr className="info">
                                          <th>Sno.</th>
                                          <th>Check In</th>
                                          <th>Check Out</th>
                                         
                                          <th>Guest Name</th>
                                          <th>Phone No</th>
                                          <th>Amount</th>
                                          <th>Advance</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {bill.bookings.map((booking, index) => (
                                          <tr>
                                            <td>{index + 1}</td>
                                            <td>{booking.checkIn}</td>
                                            <td>{booking.checkOut}</td>                                            
                                            <td>
                                              {booking.guestName}
                                            </td>
                                            <td>
                                              {booking.guestPhone}
                                            </td>
                                            <td>{booking.totalCost}</td>
                                            <td>{booking.totalAdvance}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                    <div className="totle-price">
                                      <div className="price-box">
                                        <table className="table">
                                          <tr>
                                            <td>Total Cost</td>
                                            <td>{bill.total_cost}</td>
                                          </tr>
                                          <tr>
                                            <td>Total Advance</td>
                                            <td>{ bill.total_advance} {/*totalAdvance(pindex)*/}</td>
                                          </tr>
                                           {bill.payments.map((payment, index) => (
                                             <tr>
                                             <td>{payment.date}|{payment.remark}</td>
                                             <td>{payment.amount}</td>
                                            </tr>
                                            ))}  
                                          <tr>
                                            <td>Balance</td>
                                            <td>{/*bill.total_cost - bill.total_advance*/}{totalBalnce(pindex)}</td>
                                          </tr>
                                        </table>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center">
                                No bookings found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <span>
                        Showing {page * rowsPerPage + 1} to{" "}
                        {Math.min((page + 1) * rowsPerPage, filterBills.length)}{" "}
                        of {filterBills.length} entries
                      </span>
                      <div>
                        <button
                          className="btn btn-default btn-sm mr-2"
                          onClick={() =>
                            handleChangePage(Math.max(0, page - 1))
                          }
                          disabled={page === 0}
                        >
                          Prev
                        </button>
                        <button
                          className="btn btn-default btn-sm"
                          onClick={() =>
                            handleChangePage(
                              Math.min(
                                Math.floor(filterBills.length / rowsPerPage),
                                page + 1
                              )
                            )
                          }
                          disabled={
                            (page + 1) * rowsPerPage >= filterBills.length
                          }
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="customer1"
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header modal-header-primary">
                <h3>
                  <i className="fa fa-building m-r-5"></i> Update Hotel
                </h3>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-6 form-group">
                          <label className="control-label">Hotel Name</label>
                          <input
                            type="text"
                            placeholder="Hotel Name"
                            className="form-control"
                          />
                        </div>

                        <div className="col-md-6 form-group">
                          <label className="control-label">Hotel Address</label>
                          <input
                            type="text"
                            placeholder="Hotel Address"
                            className="form-control"
                          />
                        </div>

                        <div className="col-md-6 form-group">
                          <label className="control-label">State</label>
                          <div
                            className="search-form-input-2"
                            id="second-select"
                          >
                            <select id="Tourselect">
                              <option value="disable">Select State</option>
                              <option value="AL">Uttarakhand</option>
                              <option value="WY">Punjab</option>
                              <option value="WY">Himachal</option>
                              <option value="WY">Uttar Pradesh</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-6 form-group">
                          <label className="control-label">
                            Hotel Category{" "}
                          </label>
                          <div
                            className="search-form-input-1"
                            id="first-select"
                          >
                            <select id="Cityselect">
                              <option value="disable">Hotel Category</option>
                              <option value="AL">3 Star</option>
                              <option value="WY">4 Star</option>
                              <option value="WY">5 Star</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-6 form-group">
                          <label className="control-label">
                            Contact Person Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Person Name"
                            required
                          />
                        </div>
                        <div className="col-md-6 form-group">
                          <label className="control-label">
                            Person Phone No
                          </label>
                          <input
                            type="tel"
                            className="form-control"
                            placeholder="Enter Person Phone No"
                            required
                          />
                        </div>
                        <div className="col-md-6 form-group">
                          <label>Person Email id</label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Enter Person Email id"
                            required
                          />
                        </div>
                        <div className="col-md-12 form-group user-form-group">
                          <div className="float-right">
                            <button
                              type="submit"
                              className="btn btn-add btn-sm"
                            >
                              Update Hotel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger float-left"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="hotelInfo"
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header modal-header-primary">
                <h3>
                  <i className="fa fa-building m-r-5"></i> Hotel Information
                </h3>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <table className="table px-3">
                  <tbody>
                    <tr>
                      <td>
                        <p className="mb-1">
                          <strong> Hotel Name </strong>
                        </p>
                        <p className="mb-0">Hotel Green Retreat</p>
                      </td>
                      <td>
                        <p className="mb-1">
                          <strong> Hotel Address </strong>
                        </p>
                        <p className="mb-0">Jim Corbett, Ramanagar, Nanital</p>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <p className="mb-1">
                          <strong> State </strong>
                        </p>
                        <p className="mb-0">Uttarakhand</p>
                      </td>
                      <td>
                        <p className="mb-1">
                          <strong> Hotel Category </strong>
                        </p>
                        <p className="mb-0">5 Star</p>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <p className="mb-1">
                          <strong> Contact Person Name </strong>
                        </p>
                        <p className="mb-0">Rahul Tyagi</p>
                      </td>
                      <td>
                        <p className="mb-1">
                          <strong> Contact Person Phone No </strong>
                        </p>
                        <p className="mb-0">+91 123456789</p>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <p className="mb-1">
                          <strong> Contact Person Email id </strong>
                        </p>
                        <p className="mb-0">Contact@greenretreat.com</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger float-left"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="customer2"
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header modal-header-primary">
                <h3>
                  <i className="fa fa-building m-r-5"></i> Delete Hotel
                </h3>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-12 form-group user-form-group">
                          <label className="control-label">Delete Hotel</label>
                          <div className="float-right">
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                            >
                              NO
                            </button>
                            <button
                              type="submit"
                              className="btn btn-add btn-sm"
                            >
                              YES
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger float-left"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BillingsList;
